/**
 * Strips HTML tags and decodes common HTML entities from a string.
 */
export const stripHtml = (html: string): string =>
  html
    .replace(/<[^>]*>/g, "")
    .replace(/&[^;]+;/g, " ")
    .trim();
